







import Vue from "vue"
import Datatable, {DatatableOptions} from "@/components/datatable/Datatable.vue"
import {MasterRange} from "@/model/entity/range/master-range"
import {IMasterRangeService, masterRangeService} from "@/model/service/range/master-range-service"
import {FieldDescription} from "@/model/entity/field-descriptor"

interface Data {
  listRangeService: IMasterRangeService
  options: DatatableOptions
  fields: FieldDescription[]
}

export default Vue.extend({
  components: {
    Datatable
  },
  data(): Data {
    return {
      listRangeService: masterRangeService,
      options: {},
      fields: MasterRange.getFieldDescriptionList()
    }
  }
})
